/*
    模块组件
    ChenYN

    说明
    评论弹窗

    版本
    1.0

    传参：

    依赖
    assets/less/common/util.less";
    assets/less/common/common.less";
    vue.js
    vant

    案例
    <comment-popup :show="showCommentPop" @showCommentPopup="showCommentPopup" :type="commentType" :id="commentForumId" :callback="changeList"/>
*/

<template>
    <Popup
        :transition-appear="true"
        :round="true"
        v-model:show="show"
        position="bottom"
        :close-on-popstate="true"
        :style="{ background: 'transparent' }"
    >
        <div class="pop_content" v-if="platform != 'chuangyue'">
            <textarea
                class="comment_inp"
                v-model="commentText"
                :placeholder="pageTxt.navTitle + ',' +pageTxt.forumContent"
                maxlength="500"
                ref="textareaRef"
                @touchmove.stop
            ></textarea>
            <div class="comment_img">
                <Uploader
                    max-count="1"
                    v-model="fileList"
                    preview-size="80px"
                    :preview-options="{ closeable: true }"
                    :before-read="beforeRead"
                >
                <span></span>
                </Uploader>
            </div>
        </div>
        <div class="pop_content2" v-else>
            <div class="pop_content2_box">
            <div class="bg_top"></div>
            <textarea
                class="comment_inp"
                v-model="commentText"
                :placeholder="pageTxt.navTitle + ',' +pageTxt.forumContent"
                maxlength="500"
                ref="textareaRef"
                @touchmove.stop
            ></textarea>
            <div class="comment_img">
                <Uploader
                    max-count="1"
                    v-model="fileList"
                    preview-size="80px"
                    :preview-options="{ closeable: true }"
                    :before-read="beforeRead"
                >
                <span></span>
                </Uploader>
            </div>
            </div>
        </div>
        <div class="upload">
            <Uploader
                max-count="1"
                v-model="fileList"
                :before-read="beforeRead"
                :preview-image = "false"
            >
                <img src="@/assets/images/edit_forum/icon_image.png" alt />
            </Uploader>
            <Button v-if="platform != 'chuangyue'" class="commen_send" @click="sendComment">发 布</Button>
            <Button v-else class="commen_send_2" @click="sendComment">发 布</Button>
        </div>
    </Popup>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, ref, watch} from 'vue';
import router from "@/router"
import { useStore } from 'vuex';
import { useRoute } from "vue-router"
import { Popup, Button, Uploader } from 'vant';
import Util from "@/assets/js/lib/util";

export default defineComponent({
    name: 'Comment_Popup',
    components: {Popup, Button, Uploader},
    emits: ['showCommentPopup'],
    props: ['mainObj', 'show', 'id', 'type', 'callback','closePup'],
    setup(props,{ emit }) {
        const store = useStore();
        const state = reactive({
            show: props.show,
            id: props.id,
            type: props.type,
            commentText: '',
            windowWidth: window.innerWidth,
            fileList: [],
            comment: '',
            util: new Util(),
            route: useRoute(),
            pageTxt: {
                navTitle: '回复楼主',
                forumContent: '写下你的想法......'
            },
            textareaRef: '',
            platform: ''
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            beforeRead: (file) => {
                try{
                    if(file.size > (1024 * 1024 * 10)){
                        window.Components.toast('图片不能大于10M，请压缩图片');
                        return false
                    }
                    return true
                }catch(err){}
            },
            //提交评论
            sendComment: async () => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                let type = state.type;
                let id = state.id;
                let txtKey = ''
                if(type == 'forum'){
                    txtKey = '回复';
                }else if(type == 'reply'){
                    txtKey = '回复';
                }else if(type == 'replyUser'){
                    txtKey = '回复';
                }

                if(state.commentText == '' || state.commentText.trim() == ''){
                    window.Components.toast(txtKey + '内容不能为空')
                    return;
                }
                let res = null
                let formData = new FormData();
                window.Components.toast.loading({
                    message: '发布中',
                    duration: 0,
                    forbidClick: true
                })

                //判断是哪个类型的操作
                if(type == 'forum'){
                    formData.append('tid', id)
                    formData.append('content', state.commentText)
                    if(state.fileList.length > 0){
                        formData.append('image', state.fileList[0].file)
                    }
                    res = await state.util.uploadPost("/thread/comment", formData);
                }else if(type == 'reply'){
                    formData.append('pid', id)
                    formData.append('content', state.commentText)
                    if(state.fileList.length > 0){
                        formData.append('image', state.fileList[0].file)
                    }
                    res = await state.util.uploadPost("/thread/commentReply", formData);
                }else if(type == 'replyUser'){
                    formData.append('rid', id)
                    formData.append('content', state.commentText)
                    if(state.fileList.length > 0){
                        formData.append('image', state.fileList[0].file)
                    }
                    res = await state.util.uploadPost("/thread/replyUser", formData);
                }else if(state.type == 'evaluate'){
                        res = await state.util.getJson("/game/evaluationReply", "POST", {eid: state.id, content: state.commentText}, true);
                }else if(state.type == 'evaluateGame'){
                        res = await state.util.getJson("/game/evaluate", "POST", {game_id: state.id, content: state.commentText}, true);
                }

                // console.info('这里是主题的评论====>', res)

                window.Components.toast.clear()

                console.log(111, res)

                if(res.code == 0){
                    if(res.msg == 'success') {
                        window.Components.toast(state.pageTxt.navTitle + '成功');
                    }else {
                        window.Components.toast(res.msg);
                    }
                    if(props.callback){
                        props.callback()
                    }
                    if(props.closePup){
                        props.closePup()
                    }
                    //提交成功后把输入框内容清空
                    state.commentText = ''
                    state.show = false

                }else{
                    window.Components.toast(res.msg)
                }
            },
        }; //需要对外暴露的方法

        watch(props,(newVal, oldVal) => {
            setTimeout(() => {
               if(props.show == true){
                //弹窗聚焦
                state.textareaRef.focus()
            }
            }, 100);

            state.show = props.show;
            state.id = props.id;
            state.type = props.type;
            state.commentText = '';
            state.fileList = [];
            if(state.type == 'forum'){
                state.pageTxt.navTitle = '回复楼主';
            }else if(state.type == 'reply'){
                state.pageTxt.navTitle = '回复层主';
            }else if(state.type == 'replyUser'){
                state.pageTxt.navTitle = '回复评论';
            }
        });

        watch(()=>state.show,(newVal, oldVal) => {
            emit('showCommentPopup',state.show)
            if(!newVal) {
                store.commit('changeCommmentContent', state.commentText)
            }else {
                state.commentText = store.state.commmentContent
            }
        })

        onMounted(() => {

            if(state.type == 'forum'){
                state.pageTxt.navTitle = '回复楼主';
            }else if(state.type == 'reply'){
                state.pageTxt.navTitle = '回复层主';
            }else if(state.type == 'replyUser'){
                state.pageTxt.navTitle = '回复评论';
            }

            state.platform = window.Config.platform

        });


        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./Comment_Popup.less";
</style>
